import styled from "styled-components";
import Modal from "@/atoms/account/Modal";
import React, { ReactElement, ReactNode } from "react";

const AccountModal = styled(Modal)`
  .modal-content-wrapper {
    padding: 3rem 1rem;
    max-width: 100%;
    width: ${(props) => props["$maxWidth"] || "auto"};

    ${({ theme }) => theme.media["sm"]} {
      padding: 3rem;
    }

    .modal-title {
      font-weight: bold;
      font-size: 1.75rem;
      text-align: center;
      line-height: 1.2;
      color: ${({ theme }) => theme.colors.textGray?.darker};
    }
  }
`;

interface AccountModalProps {
  isOpen?: boolean;
  onClose?: CallableFunction;
}

export const withModal = <P extends object>(
  Component: React.ComponentType<P>,
  id?: string
) => {
  type PropType = AccountModalProps & React.ComponentProps<typeof Component>;
  return function WrappedComponent(props: PropType) {
    return (
      <AccountModal isOpen={props.isOpen} onClose={props.onClose} id={id}>
        <Component {...props} />
      </AccountModal>
    );
  };
};

export default AccountModal;
